import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _regeneratorRuntime from "@babel/runtime-corejs2/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
var _createReducer;
/* eslint-disable no-underscore-dangle */import { createReducer, createAction } from 'redux-act';
import { createSelector, createStructuredSelector } from 'reselect';
import { selectIsAuthenticatedUser, selectUserCountryCode, selectUserCurrency, saveUserCountryCode, saveAuthenticatedUserInfos, saveCurrencies, saveCurrentCurrency } from '@gandi/authentication';
import { fetchCountry, selectCurrencies } from '@gandi/redux-places';
import { fetchCurrentSharing, selectCurrent, selectCurrentId } from '@gandi/redux-sharing';
import { selectRaw as selectRawState } from './utils';
import { fetchCurrencies, selectDefaultCurrency } from './currencies';
import { fetchInfos, selectGrid } from './infos';
import { selectCurrency } from './prepaid';
export var selectRaw = createSelector([selectRawState], function (raw) {
  return raw.pricing;
});
export var selectPricingIsLoaded = createSelector([selectRaw], function (raw) {
  return raw.isLoaded;
});
export var selectPricingIsFailure = createSelector([selectRaw], function (raw) {
  return raw.isFailure;
});
export var selectPricingIsToRefetch = createSelector([selectRaw], function (raw) {
  return raw.isToRefetch;
});
export var selectPricingIsFetching = createSelector([selectRaw], function (raw) {
  return raw.isFetching;
});
var selectDefaultBUCurrencyProps = createStructuredSelector({
  sharingId: selectCurrentId,
  country: selectUserCountryCode
});
var selectPrepaidCurrency_ = function selectPrepaidCurrency_(state) {
  return selectCurrency(state, {
    sharingId: selectCurrentId(state)
  });
};
var selectDefaultBUCurrency_ = function selectDefaultBUCurrency_(state) {
  return (
    // $FlowFixMe[incompatible-call] country ccan be undefined in selectDefaultCurrency, but is string in selectDefaultBUCurrencyProps.
    selectDefaultCurrency(state, selectDefaultBUCurrencyProps(state))
  );
};
var selectGuessedCurrency_ = function selectGuessedCurrency_(state) {
  var maybeCurrency = selectUserCurrency(state);
  // eslint-disable-next-line no-extra-boolean-cast
  return Boolean(maybeCurrency) ?
  // $FlowFixMe[incompatible-type]
  maybeCurrency : undefined;
};
var selectGrid_ = function selectGrid_(state) {
  return selectGrid(state, {
    sharingId: selectCurrentId(state)
  });
};
var selectCurrency_ = createSelector([selectPrepaidCurrency_, selectDefaultBUCurrency_, selectGuessedCurrency_], function (prepaidCurrency, defaultBUCurrency, guessedCurrency) {
  return prepaidCurrency || defaultBUCurrency || guessedCurrency || 'USD';
});
export var selectPricingInfos = createStructuredSelector({
  currency: selectCurrency_,
  grid: selectGrid_,
  country: selectUserCountryCode,
  sharingId: selectCurrentId
});
export var setPricingIsLoaded = createAction('[redux-billing][pricing] Set `isLoaded`');
export var setPricingIsFailure = createAction('[redux-billing][pricing] Set `isFailure`');
export var setPricingIsFetching = createAction('[redux-billing][pricing] Set `isFetching`');
export var setPricingIsToRefetch = createAction('[redux-billing][pricing] Set `isToRefetch`');
var fetchCurrenciesByCountryCode = function fetchCurrenciesByCountryCode(country) {
  return function (dispatch) {
    return dispatch(fetchCountry(country)).then(function (response) {
      dispatch(saveCurrencies(response.data.currencies));
      dispatch(saveCurrentCurrency(response.data.currencies[0]));
    });
  };
};
export var preFetchPricingInfos = function preFetchPricingInfos(currencyOverride) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(dispatch, getState) {
      var isLoggedIn, countryCode, sharingId, _currencies, org, country, bu, prepaidCurrency, currencies;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch(setPricingIsFetching());
            _context.prev = 1;
            isLoggedIn = selectIsAuthenticatedUser(getState());
            countryCode = selectUserCountryCode(getState());
            sharingId = selectCurrentId(getState());
            if (!(!isLoggedIn || !sharingId)) {
              _context.next = 12;
              break;
            }
            _context.next = 8;
            return dispatch(fetchCurrenciesByCountryCode(countryCode));
          case 8:
            _currencies = selectCurrencies(getState(), countryCode);
            if (_currencies.includes(currencyOverride)) {
              dispatch(saveCurrentCurrency(currencyOverride));
            }
            dispatch(setPricingIsLoaded());
            return _context.abrupt("return");
          case 12:
            org = selectCurrent(getState());
            if (org) {
              _context.next = 17;
              break;
            }
            _context.next = 16;
            return dispatch(fetchCurrentSharing());
          case 16:
            org = selectCurrent(getState());
          case 17:
            country = org.country || countryCode;
            _context.next = 20;
            return dispatch(fetchCurrencies({
              country: country
            }));
          case 20:
            if (!(country !== countryCode)) {
              _context.next = 24;
              break;
            }
            dispatch(saveUserCountryCode(country));
            _context.next = 24;
            return dispatch(fetchCurrenciesByCountryCode(country));
          case 24:
            bu = org.bu_id;
            prepaidCurrency = selectCurrency(getState(), {
              sharingId: sharingId
            });
            if (!prepaidCurrency) {
              _context.next = 29;
              break;
            }
            dispatch(setPricingIsLoaded());
            return _context.abrupt("return");
          case 29:
            _context.next = 31;
            return dispatch(fetchInfos({
              sharingId: sharingId
            }));
          case 31:
            prepaidCurrency = selectCurrency(getState(), {
              sharingId: sharingId
            });
            if (!prepaidCurrency) {
              _context.next = 35;
              break;
            }
            dispatch(setPricingIsLoaded());
            return _context.abrupt("return");
          case 35:
            if (!bu) {
              _context.next = 39;
              break;
            }
            dispatch(saveAuthenticatedUserInfos({
              bu_id: bu
            }));
            _context.next = 39;
            return dispatch(fetchCurrencies({
              country: country
            }));
          case 39:
            _context.next = 41;
            return dispatch(fetchCurrenciesByCountryCode(country));
          case 41:
            currencies = selectCurrencies(getState(), countryCode);
            if (currencies.includes(currencyOverride)) {
              dispatch(saveCurrentCurrency(currencyOverride));
            }
            dispatch(setPricingIsLoaded());
            return _context.abrupt("return");
          case 47:
            _context.prev = 47;
            _context.t0 = _context["catch"](1);
            dispatch(setPricingIsFailure());
            throw _context.t0;
          case 51:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 47]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var initialState = {
  isLoaded: false,
  isFetching: false,
  isFailure: false,
  isToRefetch: false
};
export var handleStateChange = function handleStateChange(flag) {
  return function (state) {
    var isLoaded = state.isLoaded,
      isFetching = state.isFetching,
      isFailure = state.isFailure,
      isToRefetch = state.isToRefetch;
    if (flag in state) {
      if (flag === 'isFailure' && (isLoaded || isFetching)) {
        return _objectSpread(_objectSpread({}, state), {}, {
          isFailure: true,
          isLoaded: false,
          isFetching: false
        });
      }
      if (flag === 'isLoaded' && (isFailure || isFetching || isToRefetch)) {
        return {
          isFailure: false,
          isLoaded: true,
          isFetching: false,
          isToRefetch: false
        };
      }

      // Update `isFetching` or `isToReFetch` to `true` if needed.
      if (!state[flag]) {
        return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, flag, true));
      }
    }
    return state;
  };
};
var reducer = createReducer((_createReducer = {}, _defineProperty(_createReducer, setPricingIsLoaded, handleStateChange('isLoaded')), _defineProperty(_createReducer, setPricingIsFetching, handleStateChange('isFetching')), _defineProperty(_createReducer, setPricingIsToRefetch, handleStateChange('isToRefetch')), _defineProperty(_createReducer, setPricingIsFailure, handleStateChange('isFailure')), _createReducer), initialState);
export default reducer;